module.exports = {
  src: __webpack_public_path__ + "placeholder-9951d025.svg",
  width: 67,
  height: 83,
  bytes: 1051,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "placeholder-9951d025.svg";
};